export default __webpack_public_path__ + "static/media/trendbuild_4.cfd67009.png";